import * as React from "react";
import { PropsWithChildren } from "react";
import { useTranslation } from "react-i18next";

type Props = PropsWithChildren<{
  sidebar: boolean;
  toggle(): void;
}>;

const Hamburger: React.FC<Props> = (props: Props) => {
  const { toggle, sidebar } = props;

  const handleKeyDown = (event: React.KeyboardEvent<HTMLDivElement>) => {
    if (event.key === "Enter") {
      toggle();
    }
  };

  const { t } = useTranslation("global");
  return (
    <div
      role="button"
      className={"m-hamburger"}
      onClick={() => toggle()}
      onKeyDown={handleKeyDown}
      tabIndex={0}
      aria-label={`${t("Abrir y cerrar el menu")}`}
    >
      <div
        className={`hamburger__bar hamburger__bar-top hamburger__bar-top${
          sidebar ? "--open hamburger__bar--sidebar" : "--close"
        }`}
      />
      <div
        className={`hamburger__bar hamburger__bar-mid hamburger__bar-mid${
          sidebar ? "--open hamburger__bar--sidebar" : "--close"
        }`}
      />
      <div
        className={`hamburger__bar hamburger__bar-bottom hamburger__bar-bottom${
          sidebar ? "--open hamburger__bar--sidebar" : "--close"
        }`}
      />
    </div>
  );
};

export default Hamburger;
